import { Button, Result } from 'antd';
import React from 'react';

import styles from './index.module.scss';

const FeatureGuideFrontDeskList = () => {
  return (
    <div className={styles.mobileSmartMail}>
      <Result
        status="warning"
        title="尚未開通此功能，請聯絡易控智慧"
        extra={
          <Button
            id={styles.mainBtn}
            type="primary"
            key="console"
            onClick={() => {
              window.location.assign('https://www.ezcontw.com/');
            }}
          >
            聯絡我們
          </Button>
        }
      />
    </div>
  );
};

export default FeatureGuideFrontDeskList;
